import Base from '../../common/Base';
import { useEffect, useState } from 'react';
import { Card, Tab, Nav, Row, Col, Container } from 'react-bootstrap';
import Gstr9cSidebar from '../sidebar/Gstr9cSidebar';
import GstrUploadBills from './../tables/GstrUploadBills';
import uploading_image from '../../../assets/images/up-loading.png';
import {
  uploadFiles,
  clearMessages,
  handleSheetApproval,
  handleSheetApprovalManager
} from '../../../slices/forms/gstr9c';
import { clearNotification } from '../../../slices/notification';
import { useDispatch, useSelector } from 'react-redux';
import BillsSidebar from '../sidebar/BillsSidebar';
import axiosInstance from '../../../services/instance';
import ChatPopup from '../../common/ChatPopup';
import ViewSheetSummary from '../ViewSheetSummary';
import toast from 'react-hot-toast';
import Loader from '../../common/Loader';
import useCheckAuthorization from '../../../hooks/checkAuthorization';
import { CRUD_PERMISSIONS } from '../../../constants/staff';

const Gstr9C = () => {
  const [key, setKey] = useState('view_form');
  const dispatch = useDispatch();
  const changeTab = (k) => {
    setKey(k);
  };
  const [uploadedBills, setUplaodedBills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sheetData, setSheetData] = useState(null);
  const [sheetSummaryData, setSheetSummaryData] = useState(null);
  const { uploadFilesSuccess, billsUploading, uploadFilesData, handleSheetApprovalState } =
    useSelector((state) => state.gstr9C);
  const { isNotificationRoute, notification } = useSelector((state) => state.notification);
  const { selectedMonth, selectedYear, selectedStartDate, selectedEndDate } = useSelector((state) => state.common);
  const isManager = useCheckAuthorization(CRUD_PERMISSIONS.sheet.client_manager_role);

  const uploadFileData = (files, section_type, notes) => {
    dispatch(uploadFiles({ start_date: selectedStartDate, end_date: selectedEndDate, files, section_type, notes }));
  };

  const handleSheetSubmit = (sheetId, status) => {
    setLoading(true);
    dispatch(
      handleSheetApproval({
        start_date: selectedStartDate,
        end_date: selectedEndDate,
        approve: status,
        isManager,
        sheetId
      })
    );
  };
  const handleSheetSubmitManager = (sheetId, status) => {
    setLoading(true);
    dispatch(
      handleSheetApprovalManager({
        start_date: selectedStartDate,
        end_date: selectedEndDate,
        approve: status,
        isManager,
        sheetId
      })
    );
  };
  const normalizeData = async (data) => {
    return data.map((item) => ({
      ...item,
      note_files: item.gstr9c_note_files
    }));
  };

  const getUploadedBills = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post('/api/v1/gstr9c/lists', {
        start_date: selectedStartDate,
        end_date: selectedEndDate,
        perPage: 10,
        page: 1
      });
      const formattedData = await normalizeData(res.data.data.list);
      setUplaodedBills(formattedData);
    } catch (error) {
      console.error('error', error);
    } finally {
      setLoading(false);
    }
  };

  const getSheet = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post('/api/v1/gstr9c/view/sheet', {
        start_date: selectedStartDate,
        end_date: selectedEndDate,
      });
      if (res.data?.data) setSheetSummaryData(res.data?.data);
      if (res.data?.data?.sheet !== null) {
        setSheetData(res.data?.data?.sheet);
      } else {
        setSheetData(null);
      }
    } catch (error) {
      console.error('error', error);
    } finally {
      setLoading(false);
    }
  };
  const clearFormUpload = async () => {
    dispatch(clearMessages(true));
    await getUploadedBills();
  };

  if (uploadFilesSuccess) {
    clearFormUpload();
  }

  if (handleSheetApprovalState.success) {
    dispatch(clearMessages(true));
    getSheet();
  }
  if (handleSheetApprovalState.error) {
    dispatch(clearMessages(true));
    getSheet();
  }

  const handleDownloadZip = async (item) => {
    try {
      const promise = axiosInstance.post(
        `/api/v1/gstr9c/download/zip`,
        {
          note_id: item.id
        },
        {
          responseType: 'blob' // Important! Tells axios to handle the response as a blob
        }
      );
      const response = await toast.promise(promise, {
        loading: 'Downloading...',
        success: <b>Downloaded!</b>,
        error: <b>Downloading Failed.</b>
      });
      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element
      const link = document.createElement('a');
      link.href = url;
      const fileName = item.notes.replace(/ /g, '_');
      link.setAttribute('download', `${fileName}.zip`); // Specify the filename

      // Append to the document and click the link to trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('error', error);
    } finally {
    }
  };

  const handleDeleteBill = async (billId) => {
    try {
      setLoading(true);
      const promise = axiosInstance.post('/api/v1/gstr9c/delete/file', {
        file_id: billId
      });
      const response = await toast.promise(promise, {
        loading: 'Deleting...',
        success: <b>Deleted!</b>,
        error: <b>Deleting Failed.</b>
      });
      getUploadedBills();
    } catch (error) {
      console.error('error', error);
    } finally {
      setLoading(false);
    }
  };

  //const { comments, summary } = useSelector((state) => state.gstr.excelData);
  useEffect(() => {
    if (key === 'stock_statement' || key === 'kpi' || key === 'ratio_analysis' || key === 'budgeting_and_forecasting' || key === 'financial_statements') {
      getUploadedBills();
    }
    if (key === 'view_form') getSheet();
  }, [key, selectedStartDate, selectedEndDate]);

  useEffect(() => {
    if (isNotificationRoute) {
      /*if(notification?.parameters?.selected_tab === 1){
        setKey('view_form');
      }else if(notification?.parameters?.selected_tab === 2){
        setKey('upload_bills');
      }*/
      dispatch(clearNotification());

    }
  }, [isNotificationRoute])

  function formatMonthYear(mmYYYY) {
    if (!mmYYYY) return '';
    const [mm, yyyy] = mmYYYY.split('-');
    // month is 0-based in Date()
    const date = new Date(Number(yyyy), Number(mm) - 1);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  }

  return (
    <Base header="gstr9c" headerTitle={'Reports'}>
      <Container fluid>
        <Card>
          <Card.Body>
            <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px' }}>
              <span
                style={{
                  backgroundColor: '#FFE5B4', // light orange
                  color: '#F37920',           // dark orange
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontWeight: '500',
                }}
              >
                {formatMonthYear(selectedStartDate)}
                &nbsp;–&nbsp;
                {formatMonthYear(selectedEndDate)}
              </span>
            </div>
            <Tab.Container id="left-tabs-example" activeKey={key} onSelect={changeTab}>
              <Nav variant="tabs" as="ul" className="pa-nav-tabs-1 gstr-tab">
                <Nav.Item as="li">
                  <Nav.Link eventKey="view_form">Others</Nav.Link>
                </Nav.Item>
              </Nav>
              {loading ? (
                <div class="text-center">Loading...</div>
              ) : (
                <Tab.Content>
                  <Tab.Pane eventKey="view_form">
                    <Row style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                      <Col xl={9}>
                        {!sheetData ? (
                          <h4 className="text-center mt-4">No Summary Uploaded For the period !</h4>
                        ) : (
                          <ViewSheetSummary
                            sheetSummaryData={sheetSummaryData}
                            handleSheetSubmit={handleSheetSubmit}
                            handleSheetSubmitManager={handleSheetSubmitManager}
                            sheetType="gstr9c"
                            getSheet={getSheet}
                          />
                        )}
                      </Col>
                      <Col xl={3}>
                        <Gstr9cSidebar activeTab={key} />
                      </Col>
                    </Row>
                  </Tab.Pane>
                  <Tab.Pane eventKey="financial_statements">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="financial_statements">
                          <Tab.Content>
                            {[
                              { key: 'financial_statements', label: 'Financial statements', section: 1 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? (
                                  <Loader content="Uploading File! Please wait. Do not refresh or press back button" />
                                ) : (
                                  <GstrUploadBills
                                    handleUploadFile={(fileData, notes) =>
                                      uploadFileData(fileData, tab.section, notes)
                                    }
                                  />
                                )}
                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar
                          uploadedBills={uploadedBills}
                          handleDownloadZip={handleDownloadZip}
                          handleDeleteBill={handleDeleteBill}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="budgeting_and_forecasting">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="budgeting_and_forecasting">
                          <Tab.Content>
                            {[
                              { key: 'budgeting_and_forecasting', label: 'Budgeting and Forecasting', section: 2 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? (
                                  <Loader content="Uploading File! Please wait. Do not refresh or press back button" />
                                ) : (
                                  <GstrUploadBills
                                    handleUploadFile={(fileData, notes) =>
                                      uploadFileData(fileData, tab.section, notes)
                                    }
                                  />
                                )}
                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar
                          uploadedBills={uploadedBills}
                          handleDownloadZip={handleDownloadZip}
                          handleDeleteBill={handleDeleteBill}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="ratio_analysis">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="ratio_analysis">
                          <Tab.Content>
                            {[
                              { key: 'ratio_analysis', label: 'Ratio Analysis', section: 3 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? (
                                  <Loader content="Uploading File! Please wait. Do not refresh or press back button" />
                                ) : (
                                  <GstrUploadBills
                                    handleUploadFile={(fileData, notes) =>
                                      uploadFileData(fileData, tab.section, notes)
                                    }
                                  />
                                )}
                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar
                          uploadedBills={uploadedBills}
                          handleDownloadZip={handleDownloadZip}
                          handleDeleteBill={handleDeleteBill}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="kpi">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="kpi">
                          <Tab.Content>
                            {[
                              { key: 'kpi', label: 'KPI', section: 4 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? (
                                  <Loader content="Uploading File! Please wait. Do not refresh or press back button" />
                                ) : (
                                  <GstrUploadBills
                                    handleUploadFile={(fileData, notes) =>
                                      uploadFileData(fileData, tab.section, notes)
                                    }
                                  />
                                )}
                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar
                          uploadedBills={uploadedBills}
                          handleDownloadZip={handleDownloadZip}
                          handleDeleteBill={handleDeleteBill}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>

                  <Tab.Pane eventKey="stock_statement">
                    <Row>
                      <Col xl={8}>
                        <Tab.Container defaultActiveKey="stock_statement">
                          <Tab.Content>
                            {[
                              { key: 'stock_statement', label: 'Stock statement', section: 5 },
                            ].map((tab) => (
                              <Tab.Pane eventKey={tab.key}>
                                <h4
                                  className="jl-heading mt-0 mb-10 inline card-title bold-font"
                                  id="Filechange">
                                  <span className="pa-upload-icon">
                                    <img src={uploading_image} alt="" />
                                  </span>
                                  {tab.label}
                                </h4>
                                {billsUploading ? (
                                  <Loader content="Uploading File! Please wait. Do not refresh or press back button" />
                                ) : (
                                  <GstrUploadBills
                                    handleUploadFile={(fileData, notes) =>
                                      uploadFileData(fileData, tab.section, notes)
                                    }
                                  />
                                )}
                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                        </Tab.Container>
                      </Col>
                      <Col xl={4}>
                        <BillsSidebar
                          uploadedBills={uploadedBills}
                          handleDownloadZip={handleDownloadZip}
                          handleDeleteBill={handleDeleteBill}
                        />
                      </Col>
                    </Row>
                  </Tab.Pane>

                </Tab.Content>
              )}
            </Tab.Container>
          </Card.Body>
        </Card>
        <ChatPopup chat_type="GSTR9C" />
      </Container>
    </Base>
  );
};
export default Gstr9C;
